"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/react-wrapper.js":
/*!****************************************!*\
  !*** ./js/components/react-wrapper.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  var props = {};
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    if (appTarget && !initialized) {
      if (propsEl) {
        var _appTarget$querySelec;
        props = {};
        props = json_6__WEBPACK_IMPORTED_MODULE_2___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
      }
      appTarget.dataset.initialized = true;
      var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_1__.createRoot)(appTarget);
      root.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Component, {
        shopifyData: props
      }));
      return root;
    }
  });
});

/***/ }),

/***/ "./js/components/react/BundleAddToCart.js":
/*!************************************************!*\
  !*** ./js/components/react/BundleAddToCart.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var bundleAddToCart = _ref => {
  var _shopifyData$data, _shopifyData$data2, _shopifyData$data3, _shopifyData$data4, _shopifyData$data5, _shopifyData$data6;
  var {
    shopifyData
  } = _ref;
  var [selectedVariant, setSelectedVariant] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var [outOfStock, setOutOfStock] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  var size = (shopifyData === null || shopifyData === void 0 || (_shopifyData$data = shopifyData.data) === null || _shopifyData$data === void 0 ? void 0 : _shopifyData$data.size) || [];
  var variants = (shopifyData === null || shopifyData === void 0 || (_shopifyData$data2 = shopifyData.data) === null || _shopifyData$data2 === void 0 ? void 0 : _shopifyData$data2.variants) || [];
  var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)('');
  var parentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)('');
  var setOpenModal = () => {
    var _parentRef$current;
    var activeModal = document.querySelector('.modal.active');
    if (activeModal) {
      activeModal.classList.remove('active');
    }
    (_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 || (_parentRef$current = _parentRef$current.querySelector('.modal')) === null || _parentRef$current === void 0 || _parentRef$current.classList.add('active');
  };
  var closeModal = () => {
    document.querySelector('.modal.active').classList.remove('active');
  };
  var setSize = size => {
    variants.map(variant => {
      if (variant.title.includes(size)) {
        var arr = variant.title.split('/');
        arr.length > 1 ? arr.forEach(elem => {
          if (elem.trim() === size) {
            setSelectedVariant(variant.id);
          }
        }) : variant.title.trim() === size && setSelectedVariant(variant.id);
      }
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var outOfStockVariant = variants.map(variant => {
      if (parseInt(variant.inventory_quantity) <= 0) {
        var options = variant.options;
        var getSize = options.find(option => {
          return size.find(sizeValue => sizeValue == option);
        });
        return getSize;
      }
    }).filter(item => item);
    setOutOfStock(outOfStockVariant);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (selectedVariant) {
      var button = buttonRef.current;
      button.click();
    }
    setSelectedVariant(false);
  }, [selectedVariant]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {}, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "bundle_add_to_cart_container",
    ref: parentRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    "data-action": "add-to-cart",
    onClick: () => size.length > 0 ? setOpenModal() : setSelectedVariant(variants[0].id)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "11",
    viewBox: "0 0 11 11",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M4.83576 10.5776V0.530389H6.32862V10.5776H4.83576ZM0.428265 6.26487V4.8668H10.7361V6.26487H0.428265Z",
    fill: "#FFF"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "size_modal modal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "size_modal_info"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Select a size"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    onClick: () => closeModal()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M1.28617 11.8929L0.107655 10.7144L4.82166 6.00041L0.107401 1.28615L1.28591 0.107642L6.00017 4.8219L10.7143 0.107812L11.8928 1.28632L7.17868 6.00041L11.8925 10.7142L10.714 11.8928L6.00017 7.17892L1.28617 11.8929Z",
    fill: "#404625"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "size_modal_sizes"
  }, size.map((size, i) => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
      key: i,
      className: outOfStock.indexOf(size) != -1 ? 'soldout size' : 'size',
      onClick: () => setSize(size)
    }, size);
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("product-form", {
    className: "product-form",
    "data-hide-errors": "false"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    method: "post",
    action: "/cart/add",
    className: "form",
    "data-type": "add-to-cart-form"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    type: "hidden",
    name: "id",
    value: selectedVariant
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    type: "hidden",
    name: "quantity",
    value: "1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    type: "hidden",
    name: "form_type",
    value: "product"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    className: "hidden",
    name: "properties[_bundleQuantity]",
    value: shopifyData === null || shopifyData === void 0 || (_shopifyData$data3 = shopifyData.data) === null || _shopifyData$data3 === void 0 ? void 0 : _shopifyData$data3.bundleQuantity
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    className: "hidden",
    name: "properties[_bundleGroupType]",
    value: shopifyData === null || shopifyData === void 0 || (_shopifyData$data4 = shopifyData.data) === null || _shopifyData$data4 === void 0 ? void 0 : _shopifyData$data4.bundleGroupType
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    className: "hidden",
    name: "properties[_collectionHandle]",
    value: shopifyData === null || shopifyData === void 0 || (_shopifyData$data5 = shopifyData.data) === null || _shopifyData$data5 === void 0 ? void 0 : _shopifyData$data5.collectionHandle
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    className: "hidden",
    name: "properties[_discountPercentage]",
    value: shopifyData === null || shopifyData === void 0 || (_shopifyData$data6 = shopifyData.data) === null || _shopifyData$data6 === void 0 ? void 0 : _shopifyData$data6.discountPercentage
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    ref: buttonRef,
    style: {
      display: "none"
    },
    id: "ProductSubmitButton-123123123123",
    type: "submit",
    name: "add"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (bundleAddToCart);

/***/ }),

/***/ "./js/components/react/bundle-progress-bar.js":
/*!****************************************************!*\
  !*** ./js/components/react/bundle-progress-bar.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    shopifyData
  } = _ref;
  var [cartLineItems, setCartItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  var {
    data
  } = shopifyData || {};
  var {
    bundleQuantity,
    collectionHandle,
    discountPercentage
  } = data;
  var activeSvg = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"113 \" height=\"5\" viewBox=\"0 0 113 5\" fill=\"none\" data-progress-bar>\n    <rect width=\"113\" height=\"5\" fill=\"#ef464e\"/>\n</svg>";
  var inactiveSvg = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"113\" height=\"5\" viewBox=\"0 0 113 5\" fill=\"none\" data-progress-bar>\n    <rect width=\"113\" height=\"5\" fill=\"#EDD3D4\"/>\n</svg>";
  var getCartData = /*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      var fetchData = yield fetch('/cart.json');
      var response = yield fetchData.json();
      var cartLineItems = response.items;
      var productsOfThisBundle = {};
      productsOfThisBundle[collectionHandle] = 0;
      cartLineItems.forEach(lineItem => {
        var _lineItem$properties, _lineItem$properties2;
        var collectionHandle = (_lineItem$properties = lineItem.properties) === null || _lineItem$properties === void 0 ? void 0 : _lineItem$properties._collectionHandle;
        var groupType = ((_lineItem$properties2 = lineItem.properties) === null || _lineItem$properties2 === void 0 ? void 0 : _lineItem$properties2._bundleGroupType) || '';
        if (groupType.toLowerCase() == "unique") {
          productsOfThisBundle[collectionHandle] = productsOfThisBundle[collectionHandle] + 1;
        } else {
          productsOfThisBundle[collectionHandle] = productsOfThisBundle[collectionHandle] + lineItem.quantity;
        }
      });
      setCartItems(productsOfThisBundle);
    });
    return function getCartData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var count = cartLineItems[collectionHandle] || 0;
  window.getCartData = getCartData;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      yield getCartData();
    })();
  }, []);
  var hideProgressBarInMobile = () => {
    var progressBar = document.querySelector('.bundle_progress');
    var footer = document.querySelector('.footer');
    if (!progressBar) return;
    if (window.scrollY + window.innerHeight - 100 > footer.offsetTop) {
      progressBar.classList.add('hide');
    } else {
      progressBar.classList.contains('hide') && progressBar.classList.remove('hide');
    }
  };
  window.addEventListener('scroll', () => {
    if (window.screen.width < 768) {
      hideProgressBarInMobile();
    }
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "bundle_progress__container container",
    style: {
      "--bundleQuantity": bundleQuantity
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "bundle_progress__offer_info"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "offer_text"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "offer_icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1213 2.37868C15.9497 1.20711 14.0503 1.20711 12.8787 2.37868L12.0758 3.18153C11.2319 4.02544 10.0873 4.49955 8.89385 4.49955H7.5C5.84314 4.49955 4.5 5.84269 4.5 7.49955V8.8934C4.5 10.0869 4.02589 11.2315 3.18198 12.0754L2.37868 12.8787C1.20711 14.0503 1.20711 15.9497 2.37868 17.1213L3.18198 17.9246C4.02589 18.7685 4.5 19.9131 4.5 21.1066V22.4995C4.5 24.1564 5.84314 25.4995 7.5 25.4995H8.89295C10.0864 25.4995 11.231 25.9737 12.0749 26.8176L12.8787 27.6213C14.0503 28.7929 15.9497 28.7929 17.1213 27.6213L17.9251 26.8176C18.769 25.9737 19.9136 25.4995 21.1071 25.4995H22.5C24.1569 25.4995 25.5 24.1564 25.5 22.4995V21.1066C25.5 19.9131 25.9741 18.7685 26.818 17.9246L27.6213 17.1213C28.7929 15.9497 28.7929 14.0503 27.6213 12.8787L26.818 12.0754C25.9741 11.2315 25.5 10.0869 25.5 8.8934V7.49955C25.5 5.84269 24.1569 4.49955 22.5 4.49955H21.1061C19.9127 4.49955 18.7681 4.02544 17.9242 3.18153L17.1213 2.37868ZM19.2481 11.3321C19.7076 10.6428 19.5213 9.71145 18.8321 9.25192C18.1428 8.7924 17.2115 8.97866 16.7519 9.66795L10.7519 18.6679C10.2924 19.3572 10.4787 20.2885 11.1679 20.7481C11.8572 21.2076 12.7885 21.0213 13.2481 20.3321L19.2481 11.3321ZM9.75 13.5C10.9926 13.5 12 12.4926 12 11.25C12 10.0074 10.9926 9 9.75 9C8.50736 9 7.5 10.0074 7.5 11.25C7.5 12.4926 8.50736 13.5 9.75 13.5ZM22.5 18.75C22.5 19.9926 21.4926 21 20.25 21C19.0074 21 18 19.9926 18 18.75C18 17.5074 19.0074 16.5 20.25 16.5C21.4926 16.5 22.5 17.5074 22.5 18.75Z",
    fill: "white"
  }))), count >= bundleQuantity ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", null, "Congratulations! You've unlocked a bundle discount of ", discountPercentage, "%!") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", null, "Add ", bundleQuantity - count, " more ", bundleQuantity - count == 1 ? 'product' : 'products', " to avail bundle discount of ", discountPercentage, "% "))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "bundle_progress__offer_bar"
  }, Array.from({
    length: bundleQuantity
  }, (_, i) => i + 1).map(item => {
    if (count < item) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
        dangerouslySetInnerHTML: {
          __html: inactiveSvg
        }
      });
    } else {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
        dangerouslySetInnerHTML: {
          __html: activeSvg
        }
      });
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "progress_label"
  }, "".concat(count, "/").concat(bundleQuantity))));
});

/***/ })

}]);